<template>
  <div class="smartPublicSecurity-layout">
    <Mobileheader name="产品与方案" routeNmae="/solutioNav" v-if="$store.state.isMobile !== 3" />
    <div v-if="pageDataList[0].isTest" style="margin-top:46px">
      <div style="left:8vw;top:4vh;position: absolute;">
        <span class="titlefont">{{ pageData.bannerTitle }}</span><br /><br />
        <button @click="dialogVisible = true" class="sendStyle">申请试用</button>
      </div>
      <img style="width: 100%;height:24vh;display: block;" src="@/assets/img/cpfaheader.png" alt="">
    </div>
    <!-- top样式-->
    <div v-else class="top-layout" :class="pageDataList[0].isTest ? '' : 'mt-top46'"
      :style="'background:url(' + pageData.bannerUrl + ');background-size: 100% 100%;background-repeat: no-repeat;'">
      <!-- <borderUpdateCom btnText="banner编辑" class="topbanner" componentsName="BannerEdit">
            <div class="bannerchange">
            </div>
          </borderUpdateCom> -->
      <div class="moban1">
      </div>
      <div class="moban2">

        <div class="title">{{ pageData.bannerTitle }}</div>

        <!-- <div class="sban-list">{{ orname }}>{{ scname }}>{{ pageObj.name }}</div> -->
      </div>
    </div>

    <!-- 服务简介-->
    <div class="content">
      <TitleCom :text="pageDataList[0].name" />
      <div class="content-layout">
        <div class="html-content swiper-no-swiping" v-html="pageDataList[0].content">
        </div>
        <img :src="pageDataList[0].imgUrl" class="sevice-img" />
      </div>
    </div>

    <!-- 痛点分析-->

    <div class="painpoint" v-show="pageDataList[1].moduleList.length > 0">
      <div class="painpoint-content">
        <TitleCom :text="pageDataList[1].name" class="titlePosition" />
        <div class="painpoint-list">
          <div v-for="(i, index) in pageDataList[1].moduleList" :key="i">
            <!-- <div class="painpoint-item"
                      :class="pageDataList[1].moduleList.length == 1 ? 'sizewidth' : pageDataList[1].moduleList.length == 2 || pageDataList[1].moduleList.length == 4 ? 'sizewidthdb' : ''"> -->
            <div class="painpoint-item" :class="index % 2 == 0 ? 'colorbg1' : 'colorbg2'">
              <div class="iconlogo">
                <img
                  :src="i.imgUrl == baseImg ? require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png') : i.imgUrl"
                  class="neicon" />
              </div>
              <div class="painpoint-title">{{ i.chtitle }}</div>
              <div class="painpoint-text">{{ i.content }}</div>
            </div>

          </div>
        </div>
      </div>

    </div>

    <!-- 核心价值-->

    <div class="coreValues" v-show="pageDataList[2].moduleList.length > 0">
      <div class="coreValues-content">
        <TitleCom :text="pageDataList[2].name" class="titlePosition" />
        <div class="coreValues-list">
          <div v-for="(i, index) in pageDataList[2].moduleList" :key="i">
            <div class="coreValues-item">
              <img :src="i.imgUrl" class="itemicon" />
              <div class="coreValues-right">
                <div class="coreValues-title">{{ i.chtitle }}</div>
                <div class="coreValues-text">{{ i.content }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 特色应用-->

    <div class="featureapplication" v-show="pageDataList[3].moduleList.length > 0">
      <div class="featureapplication-content">
        <TitleCom :text="pageDataList[3].name" class="titlePosition" />
        <div class="featureapplication-list">
          <div v-for="(i, index) in pageDataList[3].moduleList" :key="i">
            <div class="featureapplication-item">
              <div class="featureapplication-right">
                <img :src="i.imgUrl" class="itemicon" />
                <div class="featureapplication-title">{{ i.chtitle }}</div>
                <div class="featureapplication-text">{{ i.content }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> <el-dialog title="产品申请试用" :visible.sync="dialogVisible" width="90%">
      <el-form :model="ruleForm" :rules="rules" ref="addForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="产品名称：">
          <span style="font-weight: bold; color: #333;">{{ ruleForm.product }}</span>
        </el-form-item>
        <el-form-item label="联系人：" prop="name">
          <el-input v-model="ruleForm.name" :maxLength="11" style="width: 95%"></el-input>
        </el-form-item>
        <el-form-item label="联系手机：" prop="phone">
          <el-input v-model="ruleForm.phone" style="width: 95%">
            <template slot="append">获取验证码</template>
          </el-input>
        </el-form-item>
        <el-form-item label="单位名称：" prop="company">
          <el-input v-model="ruleForm.company" style="width: 95%"></el-input>
        </el-form-item>
        <el-form-item label="职务：" prop="duties">
          <el-input v-model="ruleForm.duties" style="width: 95%"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('addForm')">提交申请</el-button>
          <el-button @click="dialogVisible = false">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import TitleCom from './components/titleCom.vue';
import borderUpdateCom from './components/borderUpdateCom.vue';
import { getProgrammeCustom, addProgrammeCustom, getProgrammeCustomExist } from "@/api/pageTemplate.js";
import { baseJSON } from './base';
import { addProductUse } from "@/api/solutio.js"

export default {
  name: 'smartPublicSecurity',
  components: {
    TitleCom,

    borderUpdateCom
  },
  data() {
    let that = this

    return {
      dialogVisible: false,
      baseImg: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAABACAYAAABC6cT1AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAVZSURBVGhD7Zv9bxRFGMfvD1JjosbE4EuIP0BiTMQYftBEif5iYmKICmpERSOCGHyJVaOhGEUQFapREpJiFMWmSAiCWoUCba8gL22F9K5Xjmv7uN/rTfvs7MzNy+5cD9dv8m0DO7vzfDr7Ms8zuwXKqf4Hz5uCgw+NEPUcI/rqINHH+4je7ybq2DP7G//G/2M72rVSmYP39hO9uZvowQ6iG58muuYJe6M99sP+OE5IZQLed5ro1S6i219QA/kax8NxcfyslQr8QDQqj21WB5210Q/6y0pe4MNjRKu2qgMMbfSL/tPKGXzbfqLrV6mDapXRP+JII2vwy1cWbpR1RjyIy0dW4IMXiO7bpO58oY24Bs43AnWQEfzoENHil9SdtosRH+J0UVNwHGzRGnVn7WbE6QKvBcfp0+4jLRvx2p72SnDcMNr1mjYZcVdrDZAmUoK3293b1YjfpAQ4no/ygW55boa2/zhJZ0dKND4+bvSRk2Xa2TNJK7fU6OZnZ2hFR41e66rS0NnZ/YvnSrTnUIXW76rSDatnEv1lYdNzPgY+PKqenHy+fzIBZ+vvj0xEN55ZOPwRvvmlEtveP1yi5W9MJfpMa3CAR6cYuO4UPz9qN9I6HyuWafHa+ZHt3Hs50eaR92qxPrPw6k8bYArNgSMBUO0My0H6uG+wHGVb8/AffRc/i8YuhoHXJTZz4M2yLB6g8O6DFXq8s0Zrtl+hQ8fLyjay/5DgO/cmL6Gs4cGlUh28b1i9k7AcHG5cfPt1TxEd7reDN438yD/j9NA72V7z4JNVB0eyr9pBmAcGP/B2MrC1O6qJdjrL8Nv2hYUHn6w6+B0vqncQ5kHB97+VDhzm8Nc+GRYefLIKqG2pGnPzgOAvoscb3+5yqnO3El6u4RVQ2FM15ObBCPvc3FT+fSB+2n/yQ/KGlwU8OLkKqGqqGnLLgWRtjPyi58OOPDi5CjYlYB5EKP92qky3NuDhrdLIj4ylg7/pmQZxQwVVI9nFxhw7tAFvGnnVjdXWRTaFtQLvPhyfX4e0Gb7kDY8VGyErcNzAeOehfTTK7gQ8vOOn5GmvmkuYjOUqIStwGFkU7zy0ZfjPorSYb/cZeazVCVmDL31lmgb/bi088noOL6fHGHkXeCxUClmDw0vXTdeLCLzz0P71RDkWw7dSPg/4ZRunY210xiqtkBM4fNf61sOv21md6x+THXk7ih08Rp29R1z47g3TdOZC6+B39VRi/Z88He/73Ggptl1nr2tc9j3R6WVbg0vrrEbc666u8r2vTwWHt7nGMQi8jc7Oz/FmXrZxKnVNTmd5MvPlz+lmcrGZG+awqkYuXr5pqv5c5UGlddaJS2KubpOd2Rh/+azgQ+TpiezMJh+39Sx8HMLVx4vNoVGN9cnSEvm4TQXGxQjKFx7QvP6ugvatwiYqMPhhqrm5GvAIkgdtsgwtV18vXvKHVtbc8MNUZfUxgkSwPHidT0QTEhP0ox/419u1VVZTXd3XCNYED+g7X55/DmcNDWvr6lCo99UQ9CUN/ECU7XHoD7vja2rYLy1005UUqNnaWVpjuZgDwafOlGhJlOqKNhu6knV5VHH5cXxsXDuDsLqo2jkLP/xujQ78NVFPKL7urcRGGr4teoT1/jlRB+7pm6AVHe6PLNlWq6WQbn38arTT+jikeiPiarTTGxFCuXwHBsJbQ7l86wnK5XtuQrl8s1EIB2v3kUd8LtCQERzC6dOu1zzisj29uazAoVy+r86F5+NCT3LQv+k5bZIzOJTLb1K4kACEyupkox9dwuGjVOBCufvuTCXUtlDYQ1XzP/+lYTOpvi0F5MJ+W0r0L9m9Vfq7xsa5AAAAAElFTkSuQmCC',
      orname: '',// 父级name
      scname: '',// 第二级name
      pageObj: {},// 上一页传过来的数据
      pageData: {},// 当前页面数据
      ruleForm: {},
      pageDataList: [{ moduleList: [] }, { moduleList: [] }, { moduleList: [] }, { moduleList: [] }],//当前也数据列表

      rules: {
        name: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' },
          { min: 11, max: 11, message: '长度在 11 个字符', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入联系人单位名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        duties: [
          { required: true, message: '请输入你的职务', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],

      },
    }
  },
  watch: {
    '$store.state.changeRefresh'() {
      this.getData()
    },
    'pageDataList[1].moduleList': {
      handler: function (newVal, oldVal) {
        if (newVal.length == 2) {
          // 更新painpoint-list的flex样式
          this.updateFlexStyle(2);
        }
      },
      deep: true
    }

  },
  mounted() {

    this.orname = this.$route.query.orname;
    this.scname = this.$route.query.scname;
    this.pageObj = JSON.parse(this.$route.query.data);
    getProgrammeCustomExist({
      isRelease: this.$store.state.editStatus,
      proProgrammeId: this.pageObj.id
    }).then(res => {
      if (res.data) {
        this.getData();
      } else {
        this.saveBaseData();
      }


    })

  },
  methods: {
    submitForm(ref) {
      this.$refs[ref].validate((valid) => {
        if (valid) {
          addProductUse(this.ruleForm).then(res => {
            this.$message.success('提交成功');
            this.dialogVisible = false;
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    getData() {
      getProgrammeCustom({
        isRelease: this.$store.state.editStatus,
        proProgrammeId: this.pageObj.id
      }).then(res => {
        this.$store.commit('saveProProgrammeId', this.pageObj.id)
        this.$store.commit('savePageTemplateData', JSON.parse(JSON.stringify(res.data)))
        this.pageData = res.data
        this.ruleForm.product = this.pageData.bannerTitle;

        this.pageDataList = this.pageData.customDetailList.map(item => {
          return {
            ...JSON.parse(item.content),
            name: item.name
          }
        })

        // if (res.code == 500000) {
        // this.saveBaseData()
        // }
      })
    },

    //保存初始数据
    saveBaseData() {

      let customDetailList = baseJSON.map((item, index) => {
        return {
          content: JSON.stringify(item),
          isRelease: 0,
          name: item.title,
          sort: index
        }
      })
      let param = {
        "bannerTitle": this.pageObj.name,
        "bannerUrl": require('@/assets/img/childrenpage/smartPublicSecurity/indexbg.jpg'),
        "customDetailList": customDetailList,
        "isRelease": 0,
        "proProgrammeId": this.pageObj.id,

      };
      addProgrammeCustom(param).then(res => {

        this.getData();
      })
    },
  }
}

</script>
<style  lang="scss" scoped>
.smartPublicSecurity-layout {
  // background: rgba(233, 235, 239, 1);
  width: 100%;
  height: 100%;

  // margin-top: 60px;
  .swiper {
    height: 100vh;
  }

  /* 顶部样式 */
  .top-layout {
    width: 100vw;
    height: 212px;
    // margin-top: 46px;
    // background: url('../../../../assets/img/childrenpage/smartPublicSecurity/indexbg.jpg');
    display: flex;
    // justify-content: center;
    position: relative;

    .moban1 {
      width: 100%;
      height: 100%;
      background: rgba(42, 108, 237, 0.5);

      // margin-bottom: -20px;
    }

    .moban2 {
      width: 100%;
      height: 76px;
      background: rgba(42, 108, 237, 0.6);

      position: absolute;
      z-index: 100;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .title {
        font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold',
          'PingFang SC ExtraLight', 'PingFang SC', sans-serif;
        font-weight: 650;
        font-style: normal;
        font-size: 38px;
        color: #ffffff;
      }

      .sban-list {
        font-family: 'PingFang-SC-ExtraLight', 'PingFang SC ExtraLight',
          'PingFang SC', sans-serif;
        font-weight: 400;
        font-style: normal;
        color: #ffffff;
        margin-top: 30px;
      }
    }
  }

  /* 服务简介 */
  .content {
    padding: 4vh 10vw 4vh 10vw;
    // background-image: url('../../../../assets/img/childrenpage/smartPublicSecurity/corebg.jpg');
    // background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .content-layout {
      // display: flex;
      // justify-content: space-between;
      margin-top: 3vh;

      .html-content {
        width: 85vw;
        font-size: 26px;
        line-height: 34px;

      }

      .sevice-img {
        width: 634px;
        height: 367px;
        margin-top: 3vh;
      }
    }
  }

  /* 痛点分析 */
  .painpoint {
    width: 100%;
    // height: 100vh;
    // background: rgba(233, 235, 239, 1);
    display: flex;
    background-image: url('../../../../assets/img/childrenpage/smartPublicSecurity/corebg.jpg');
    background-size: 100% 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .painpoint-content {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      // margin: 0 auto;
      background: #ffffff;
      margin-top: 140px;
      padding-bottom: 120px;

      .titlePosition {
        margin-top: 5vh;
        margin-bottom: 3vh;
        // margin-left: 350px;
      }

      .painpoint-list {
        width: 100%;
        margin-left: 29px;
        // margin-right: 29px;

        // width: 1800px;
        // width: 100%;
        // height: 72vh;

        // height: 650px;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        // justify-content: center;
        // align-items: center;

        .colorbg1 {
          background-color: rgb(124, 166, 250) !important;
          color: #ffffff !important;
        }

        .colorbg2 {
          background-color: rgba(247, 248, 247, 1) !important;
          color: #333333 !important;
        }

        .painpoint-item {
          width: 328px;
          // max-height: 260px;
          // margin-top: 55px;
          // margin-top: 1vh;

          width: calc(100vw - 58px) !important;
          min-height: 304px;
          padding: 16px;

          // height: 206px;
          // width: 663px;
          // overflow: hidden;
          .painpoint-title {
            font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold',
              'PingFang SC ExtraLight', 'PingFang SC', sans-serif;
            font-weight: 650;
            font-style: normal;
            font-size: 26px;
            margin-top: 10px;
          }

          .painpoint-text {
            font-family: 'PingFang-SC-ExtraLight', 'PingFang SC ExtraLight',
              'PingFang SC', sans-serif;
            font-weight: 400;
            font-style: normal;
            font-size: 26px;
            line-height: 32px;
            margin-top: 10px;
          }

          .iconlogo {
            width: 61px;
            height: 61px;
            // background: url('../../../../assets/img/childrenpage/smartPublicSecurity/iconbg1.svg');
            // background-size: 100% 100%;
            // background-repeat: no-repeat;
            text-align: center;
            line-height: 80px;

            .neicon {
              width: 61px;
              height: 61px;
            }
          }
        }
      }
    }
  }

  /* 核心价值 */
  .coreValues {
    width: 100vw;
    // height: 100vh;
    background: url('../../../../assets/img/childrenpage/smartPublicSecurity/corebg.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .coreValues-content {
      display: flex;
      justify-content: center;
      align-items: center;
      // position: relative;
      flex-direction: column;
      // top: 10vh;
      padding-bottom: 140px;

      .titlePosition {
        margin-top: 60px;
        margin-bottom: 40px;
      }

      .coreValues-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        .coreValues-item {
          min-height: 174px;
          width: 631px;
          background: #ffffff60;
          // background: url('../../../../assets/img/childrenpage/smartPublicSecurity/coreitem.svg');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          display: flex;
          align-items: center;
          margin-top: 24px;
          padding: 16px;
          // padding-right: 30px;

          .itemicon {
            width: 103px;
            height: 101px;
            // margin-left: 30px;
            border-radius: 10px;
          }

          .coreValues-right {
            margin-left: 12px;

            // height: 60%;
            .coreValues-title {
              font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold',
                'PingFang SC ExtraLight', 'PingFang SC', sans-serif;
              font-weight: 650;
              font-style: normal;
              font-size: 26px;
            }

            .coreValues-text {
              font-family: 'PingFang-SC-ExtraLight', 'PingFang SC ExtraLight',
                'PingFang SC', sans-serif;
              font-weight: 400;
              font-style: normal;
              font-size: 26px;
              line-height: 34px;
            }
          }
        }
      }
    }
  }

  /* 特色应用 */
  .featureapplication {
    width: 100vw;
    // height: 100vh;
    background: url('../../../../assets/img/childrenpage/smartPublicSecurity/planbg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .featureapplication-content {
      width: 100%;
      display: flex;
      // justify-content: center;
      align-items: center;
      background: rgba($color: #ffffff, $alpha: 0.9);
      background-size: 100% 100%;
      position: relative;
      flex-direction: column;
      padding-bottom: 30px;

      // padding-top: 80px;
      .titlePosition {
        margin-top: 60px;
        margin-bottom: 40px;
      }

      .featureapplication-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        // margin-top: 2vh;
        width: 92vw;

        .featureapplication-item {
          width: 650px;
          min-height: 206px;

          display: flex;
          align-items: center;
          margin-left: 45px;
          margin-right: 45px;
          // margin-top: 20px;

          .itemicon {
            // padding-top: 10px;
            width: 370px;
            height: 224px;
            margin-bottom: 10px;
            border-radius: 10px;

            // margin-left: 30px;
          }

          .featureapplication-right {
            // width: 540px;
            width: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center; // margin-left: 30px;

            .featureapplication-title {
              font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold',
                'PingFang SC ExtraLight', 'PingFang SC', sans-serif;
              font-weight: 650;
              font-style: normal;
              margin-top: 12px;
              font-size: 26px;
            }

            .featureapplication-text {
              font-family: 'PingFang-SC-ExtraLight', 'PingFang SC ExtraLight',
                'PingFang SC', sans-serif;
              font-weight: 400;
              font-style: normal;
              font-size: 26px;
              line-height: 34px;
              margin-top: 10px;
              overflow: hidden;
            }

            // width: 408px;
          }
        }
      }
    }
  }
}

.bannerchange {
  // background: rgba(47, 147, 247, 0.8);
  position: absolute;
  // top: 60px;
  width: 100%;
  height: calc(22vh + 2px);
}

.topbanner {
  margin-top: 60px;
}

.onTrials {
  position: fixed;
  bottom: 110px;
  width: 182px;
  height: 100px;
  right: 0;
  cursor: pointer;
}

.sendStyle {
  color: white;
  font-size: 20px;
  background-color: #3564f2;
  border-radius: 60px;
  border: none;
  width: 150px;
  height: 60px;
  cursor: pointer;
}

.titlefont {
  font-size: 54px;
  font-weight: bold;
}

.mt-top46 {
  margin-top: 46px;
}
</style>

<style lang="scss">
.html-content {
  width: 85vw;
  font-size: 26px;
  line-height: 34px;

  p {
    font-size: 26px !important;
  }

}
</style>